import { render, staticRenderFns } from "./superBOrder.vue?vue&type=template&id=25d214ea&"
import script from "./superBOrder.vue?vue&type=script&lang=js&"
export * from "./superBOrder.vue?vue&type=script&lang=js&"
import style0 from "./superBOrder.vue?vue&type=style&index=0&id=25d214ea&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports